import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"refresh\"><path d=\"M448 285h-74v19c0 67-54 122-121 122s-122-55-122-122 55-122 122-122h16v96l29-32 108-108-12-13-96-96-26-29v90h-16C141 90 48 186 48 301s93 211 208 211 208-96 208-211v-16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/refresh.svg
// module id = 190
// module chunks = 0